<template>
  <div id="app">
    <router-view v-if='isRouterAlive'></router-view>

  </div>
</template>

<script>
export default {
  data(){
    return {
      active: 0,
      isRouterAlive:true,
    };
  },
  provide(){
    return {
      reload:this.reload
    }
  },
  methods: {
    reload(){
      this.isRouterAlive=false;
      this.$nextTick(function(){
        this.isRouterAlive=true;
      })
    }
  },
};
</script>
<style src='../src/assets/lib/common.css'></style>

<style>
.van-tabbar-item__icon img{
  height:0.50rem
}
.van-tabbar-item{
  font-size:0.24rem
}
.van-swipe{
  width:100%;
  height: 100%;
}
.van-swipe-item img{
  width:100%;
  height:100%;
  display: block;
}
.van-tabbar{
  	box-shadow: 0.01rem 0.06rem 0.17rem 0.01rem
		rgba(92, 86, 86, 0.23);
}
.warranty-item .van-tabs--line .van-tabs__wrap{
    height:1rem;
    border-bottom:1px solid  #d9e2e9;
}
.warranty-item .van-tab{
  color: #999999;
  font-size: 0.3rem;
  font-family: PingFang-SC-Medium;
}
.warranty-item .van-tab--active{
   color:#0d84fe;
   font-family: PingFang-SC-Bold;
}
.warranty-item .van-tabs__line {
    background-color: #0d84fe;
}
.sure .van-dialog__message{
  font-size:0.32rem
}
.van-button__text{
   color:#47a4ff;
}
.van-dialog__content{
  min-height:0.8rem
}
.bottom .van-button__text{
   color:#fff!important
}
.uploadImage .van-uploader__preview-image {
  width: 1.5rem;
  height: 1.5rem;
}
.uploadImage .van-uploader__upload {
  width: 1.5rem;
  height: 1.5rem;
  margin: 0  0 8px 0;
}
.uploadImage .van-uploader__preview:nth-child(4)
{
margin: 0  0 8px 0;
}
.uploadImage .van-uploader__preview:nth-child(8)
{
margin: 0  0 8px 0;
}
  .inputItem .van-radio__label{
  line-height: unset;
}
</style>
